import useApi, { ApiOptions } from '../base/useApi';
import ProductionCompanyDTO from '@src/adapters/dto/productionCompany/ProductionCompanyDTO';
interface Params {
  name: string;
}

interface Result {
  productionCompany: ProductionCompanyDTO;
}

const options: ApiOptions = {
  method: 'post',
  urlPath: '/production_company',
  baseUrl: process.env.REACT_APP_API_URL!,
  lazy: false,
};

export const useSaveProductionCompanyLazy = (params?: Params) => {
  options.lazy = true;
  return useApi<Params, Result>(options, params);
};

export default useSaveProductionCompanyLazy;
